
import { createContext } from "react";
import { Session, User } from "@supabase/supabase-js";
import { Profile, Organization } from "./types";

// Context type
export type AuthContextType = {
  session: Session | null;
  user: User | null;
  isLoading: boolean;
  loading: boolean; // Alias for isLoading for backward compatibility
  signOut: () => Promise<void>;
  organization: Organization | null;
  profile: Profile | null;
  profileLoaded: boolean;
};

// Create context with better default values to prevent white screens
export const AuthContext = createContext<AuthContextType>({
  session: null,
  user: null,
  isLoading: true,
  loading: true,
  signOut: async () => { console.log("Default sign out called"); },
  organization: null,
  profile: null,
  profileLoaded: false,
});
